import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_a1668682-6cd0-4608-a6a8-d20136862eb0/artifacts/fhi5ktps_IMG_9483.jpeg";
const SOCIAL_LOGO =
  "https://customer-assets.emergentagent.com/job_wunberg-paints/artifacts/pgzq2taw_E8919242-AEE6-488E-B6D4-EC043630FB4C.jpeg";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#030710] mt-24">
      <div className="wb-container py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Wünberg" className="w-12 h-12 object-cover border border-white/10" />
            <div>
              <div className="font-serif text-xl">Wünberg</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4af37]">Paint &amp; Coating</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#a0aabf] leading-relaxed">
            Sanatçıların ve hobi tutkunlarının seçimi. Yüksek pigment yoğunluklu,
            UV dayanımlı premium akrilik boyalar.
          </p>
        </div>

        <div>
          <div className="wb-overline mb-4">Keşfet</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/urunler" className="wb-link" data-testid="footer-link-products">Ürünler</Link></li>
            <li><Link to="/kalite-karsilastirma" className="wb-link" data-testid="footer-link-comparison">Kalite Karşılaştırma</Link></li>
            <li><Link to="/hakkimizda" className="wb-link" data-testid="footer-link-about">Hakkımızda</Link></li>
            <li><Link to="/blog" className="wb-link" data-testid="footer-link-blog">Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="wb-overline mb-4">Bayilik</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/bayi-basvuru" className="wb-link" data-testid="footer-link-apply">Bayi Başvurusu</Link></li>
            <li><Link to="/bayi-girisi" className="wb-link" data-testid="footer-link-dealer-login">Bayi Girişi</Link></li>
            <li><Link to="/iletisim" className="wb-link" data-testid="footer-link-contact">İletişim</Link></li>
          </ul>
        </div>

        <div>
          <div className="wb-overline mb-4">İletişim</div>
          <ul className="space-y-3 text-sm text-[#a0aabf]">
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#d4af37]" /> info@cebitech.com.tr</li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#d4af37]" /> 0544 222 6 1 07</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="text-[#d4af37] mt-0.5" /> Yeşilbahçe Mah. 1428 Sok. No: 48/A<br />Muratpaşa / ANTALYA</li>
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <a href="https://instagram.com/wunbergakrilikboya" target="_blank" rel="noopener noreferrer" aria-label="instagram" className="group flex items-center gap-2" data-testid="footer-instagram">
              <img src={SOCIAL_LOGO} alt="Wünberg Akrilik Boya Instagram" className="w-10 h-10 rounded-full object-cover border border-white/10 group-hover:border-[#d4af37] transition-colors" />
              <span className="text-xs text-[#a0aabf] group-hover:text-[#d4af37] transition-colors">@wunbergakrilikboya</span>
            </a>
          </div>
          <div className="mt-3 flex gap-3">
            <a href="https://instagram.com/wunbergakrilikboya" target="_blank" rel="noopener noreferrer" aria-label="instagram" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" aria-label="facebook" title="Facebook yakında" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition-colors opacity-60" data-testid="footer-facebook">
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-[#02060f]">
        <div className="wb-container py-6 text-xs text-[#a0aabf] leading-relaxed">
          <span className="text-[#fdfbf7]">Çebi Havacılık Turizm Org. Bil. Teks. İnş. Res. Oto Eml. San. ve Tic. Ltd. Şti.</span>
          <span className="mx-2 text-white/20">·</span>
          Antalya Kurumlar VD <span className="font-mono">2330655311</span>
          <span className="mx-2 text-white/20">·</span>
          Yeşilbahçe Mah. 1428 Sok. No: 48/A Muratpaşa / Antalya
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="wb-container py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#a0aabf]">
          <div>© {new Date().getFullYear()} Wünberg Paint &amp; Coating. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-5">
            <Link to="/admin/login" className="hover:text-[#d4af37]" data-testid="footer-admin-link">Admin</Link>
            <span>KVKK</span>
            <span>Çerez Politikası</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
